<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import { onMount } from 'svelte';
    import { get, post } from '../../utils.js';
    import { sgettext } from '../../i18n.js';
    import {object, string} from 'yup';
    import {validateForm} from '../Form/utils.js';
    import Attachments from './Attachments.svelte';
    import ApproversList from './ApproversList.svelte';
    import ApprovalForm from './ApprovalForm.svelte';
    import Button from '../Button.svelte';
    import Comments from '../common/Comments/Comments.svelte';
    import ConfirmationModal from '../ConfirmationModal.svelte';
    import Errors from '../Errors.svelte';
    import Modal from '../Modal.svelte';

    import {
        diff,
        approvalInfo,
        diffLoading,
        fioriComplete,
        isRequestNumberValid,
    } from './diffStore.js';
    import {
        canRaiseRequest,
        isEditableTemplate,
        isReviewTemplate,
        isControlTemplate,
        isRiskTemplate,
        isStrategyTemplate,
    } from './utils.js';

    export let modalId = 'approvalDialog';
    export let avId;
    export let branch = 1;
    export let d2Configured = false;
    export let documentNumber = null;
    export let awaitingReview = false;

    export let commentsUrl = `${PATH_PREFIX}/sw/api/builder/approval/{0}/comments/`;
    export let purposeUrl = `${PATH_PREFIX}/sw/api/builder/approval/{0}/purpose/`;
    export let postUrl = `${PATH_PREFIX}/sw/api/builder/approval/{0}/request/`;
    export let summaryUrl = `${PATH_PREFIX}/sw/builder/activityversion/{0}/detail/`;
    export let withdrawalUrl = `${PATH_PREFIX}/sw/api/builder/approval/{0}/withdraw/`;
    export let reviewersUrl = `${PATH_PREFIX}/sw/api/builder/activityversion/{0}/reviewers/`;
    export let approversUrl = `${PATH_PREFIX}/sw/api/builder/activityversion/{0}/approvers/`;

    var approvalComments = [];
    var isCommentLogExpanded = false;
    var loadingComments = false;
    var comment = '';
    var purpose = '';
    let fieldIsValid = initialFieldValidations();
    let errors = null;

    $: reviewers = null;
    let bypassedReviewers = [];

    $: controlOwners = null;
    $: requiredControlOwners = $diff.control_owner_users
    let bypassedControlOwners = [];

    let individualToGroupConverted = new Set();
    let groupToIndividualConverted = new Set();
    let stratApprovers = null;
    let activityApprovers = null;
    let media = null;
    let mediaInput;

    $: isRequest = isEditableTemplate($approvalInfo)
    $: title = isRequest
        ? (reviewers?.length ? sgettext('$$REQUEST_REVIEW$$') : sgettext("$$REQUEST_APPROVAL$$"))
        : (awaitingReview ? sgettext("$$PROCEED_SUMMARY_ENDORSEMENT$$") :sgettext('$$PROCEED_SUMMARY_APPROVAL$$'));
    $: submitButtonText = isRequest && reviewers?.length ? sgettext('$$SEND_ENDORSEMENT$$') : sgettext('$$SEND_APPROVAL$$');
    $: isDisabled = !canRaiseRequest($approvalInfo, $fioriComplete, $isRequestNumberValid) || $diffLoading;
    $: cleanupAttachments = false;
    $: attachments = [];

    let errorMessage = null;
    let sending = false;
    let approved = false;
    let schema = object().shape({
        comment: string().required(sgettext("$$REQUIRED_FIELD$$")),
        purpose: string().required(sgettext("$$REQUIRED_FIELD$$"))
    });

    let controlOwnerTooltipText = [sgettext('$$CONTROL_OWNERS_BYPASSED_CHANGES_RELATED$$')]
    let reviewerTooltipText = [sgettext('$$INDIVIDUAL_REVIEWERS_MUST_REVIEW$$'), sgettext('$$1_GROUP_REVIEWER_MUST_REVIEW$$')]

    function onCancel() {
        cleanupAttachments = true;
        jQuery(`#${modalId}`).modal('hide');
    }

    function showDialog() {
        jQuery(`#${modalId}`).modal('show');
    }

    function handleDecline() {
        handleConfirm(false);
    }

    function handleApprove() {
        handleConfirm(true);
    }

    function initialFieldValidations() {
        return {
            purpose: {
                isValid: true,
                errors: '',
            },
            comment: {
                isValid: true,
                errors: '',
            },
        };
    }

    function handleBypassReviewer(event) {
        const user_id = event.detail.user_id;
        bypassedReviewers = [...bypassedReviewers, user_id]

        // bypassing reviewer supersedes switching the reviewer type
        if(individualToGroupConverted.has(user_id)) individualToGroupConverted.delete(user_id);
        if(groupToIndividualConverted.has(user_id)) groupToIndividualConverted.delete(user_id);
    }

    $: if(reviewers){
        reviewers = reviewers.filter(r => !bypassedReviewers.includes(r.user_id))
    }

    function handleBypassControlOwner(event) {
        const user_id = event.detail.user_id;
        bypassedControlOwners = [...bypassedControlOwners, user_id]
    }

    $: if (controlOwners) {
        controlOwners = controlOwners.filter(co => !bypassedControlOwners.includes(co.user_id))
    }

    function handleRegroupReviewer(event) {
        const reviewer_sup_id = event.detail.id;
        const user_id = event.detail.user_id;
        const newType = event.detail.type;
        const actualType = reviewers.find(r => r.id == reviewer_sup_id)?.type;

        if (newType !== actualType) {
            if(actualType === "Individual") {
                individualToGroupConverted.add(user_id);
            }
            else {
                groupToIndividualConverted.add(user_id);
            }
        }
        else {
            if(actualType === "Individual") {
                individualToGroupConverted.delete(user_id);
            }
            else {
                groupToIndividualConverted.delete(user_id);
            }
        }
    }

    async function getReviewers() {
        const response = await get(reviewersUrl);
        if (response.ok) {
            const res = await response.json();
            reviewers = res.reviewers;
        } else {
            const error = await response.json();
            if (error.hasOwnProperty('error')) {
                errors = error;
            }
        }
    }

    async function getApprovers() {
        const response = await get(approversUrl);
        if (response.ok) {
            const res = await response.json();
            stratApprovers = res.strategy_approvers;
            activityApprovers = res.activity_approvers;
            controlOwners = res.control_owners;
        } else {
            const error = await response.json();
            if (error.hasOwnProperty('error')) {
                errors = error;
            }
        }
    }

    async function handleConfirm(decision) {
        try {
            sending = true;
            approved = decision;
            var data = {
                    purpose: purpose,
                    comment: comment
                }
            await validateForm(schema, data);

            let allAttachmentsUploaded = attachments.every(attachment => attachment.hasOwnProperty('id'));
            if (!allAttachmentsUploaded) {
                errorMessage = sgettext('$$ATTACHMENTS_MUST_UPLOADED_SUBMITTING$$')
                sending = false;
                return;
            } 

            let payload =  {
                progress: decision,
                comment: comment,
                purpose: purpose,
                bypassed_reviewers: bypassedReviewers,
                individual_to_group_converted: Array.from(individualToGroupConverted),
                group_to_individual_converted: Array.from(groupToIndividualConverted),
                bypassed_control_owners: bypassedControlOwners,
                attachments: attachments.map(attachment => attachment.id)
            }
            const response = await post(postUrl, payload);
            
            if (response) {
                const res = await response.json();
                jQuery(modalId).modal('hide');
                window.location = res.url;
            } else {
                errorMessage = sgettext('$$FAILED_SUBMIT_FORM_UNKNOWN_REASON$$')
                sending = false;
            }
        } catch (errors) {
            fieldIsValid = initialFieldValidations();
            errors.inner.forEach((er) => {
                fieldIsValid[er.path].isValid = false;
                fieldIsValid[er.path].errors = er.message;
            })
            sending = false;
        }
    }

    function viewSummary() {
        window.location = summaryUrl;
    }

    function showWithdrawalDialog() {
        jQuery(`#withdrawalModal`).modal('show');
    }

    async function withdrawRequest() {
        sending = true;
        const response = await post(withdrawalUrl, { progress: true,
                                    comment: sgettext('$$APPROVAL_REQUEST_WITHDRAWN$$') });
        if (response.ok) {
            const res = await response.json();
            window.location = res.url;
        } else {
            sending = false;
        }
    }

    function cancelWithdrawal() {
        jQuery(`#withdrawalModal`).modal('hide');
    }

    onMount(async () => {
        loadingComments = true;
        const response = await get(commentsUrl);
        approvalComments = await response.json();
        loadingComments = false;
        const purposeResponse = await get(purposeUrl);
        const purposeContent = await purposeResponse.json();
        purpose = purposeContent.purpose;
        await getReviewers();
        await getApprovers();
    });

</script>

{#if ($approvalInfo.raisedRequest || $approvalInfo.isSystemAdmin || $approvalInfo.isBranchAdmin) && !isRequest && (isReviewTemplate($approvalInfo) || isControlTemplate($approvalInfo) || isStrategyTemplate($approvalInfo) || isRiskTemplate($approvalInfo))}
  <li class="nav-item">
    <Button
      name={sgettext('$$WITHDRAW_REQUEST$$')}
      type="secondary"
      on:click={showWithdrawalDialog}
    />
  </li>
{/if}

<li class="nav-item tooltip-parent">
  <Button
    name={title}
    type="primary"
    disabled={isDisabled}
    on:click={isRequest ? showDialog : viewSummary}
  />
  {#if $approvalInfo.errorMessage && isDisabled}
    <span class="tooltiptext">{@html $approvalInfo.errorMessage}</span>
  {/if}
</li>

<Modal id={modalId} {title} extraLarge={true}>
  <div slot="body">
    <div class="d-flex justify-content-between">
      <!-- LEFT COLUMN -->
      <div style="width: 50%;" class="mr-2" data-testid="workflow-participants">
        <label style="font-size: 1.1rem;" class="mb-2"
          >{sgettext('$$WORKFLOW_PARTICIPANTS$$')}</label
        >
        <Errors errors={errorMessage} />
        <ApproversList
          title={sgettext('$$REVIEWER_1$$')}
          tooltipText={reviewerTooltipText}
          noApproversLabel={sgettext('$$REVIEWERS_CONFIGURED$$')}
          users={reviewers}
          userType="reviewer"
          readonly={false}
          isExpanded={true}
          on:bypass={handleBypassReviewer}
          on:regroup={handleRegroupReviewer}
        />

        <ApproversList
          title={sgettext('$$CONTROL_OWNER_1$$')}
          tooltipText={controlOwnerTooltipText}
          noApproversLabel={sgettext('$$CONTROL_OWNERS_CONFIGURED$$')}
          users={controlOwners}
          requiredUsers={requiredControlOwners}
          userType="control-owner"
          readonly={false}
          isExpanded={true}
          on:bypass={handleBypassControlOwner}
        />

        <ApproversList
          title={sgettext('$$STRATEGY_APPROVER_1$$')}
          noApproversLabel={sgettext('$$STRATEGY_APPROVERS_CONFIGURED$$')}
          users={stratApprovers}
          userType="strategy-approver"
          readonly={true}
          isExpanded={false}
        />

        <ApproversList
          title={sgettext('$$ACTIVITY_APPROVER_1$$')}
          noApproversLabel={sgettext('$$ACTIVITY_APPROVERS_CONFIGURED_1$$')}
          users={activityApprovers}
          userType="activity-approver"
          readonly={true}
          isExpanded={false}
        />
      </div>

      <!-- RIGHT COLUMN -->
      <div style="width: 50%;" class="ml-2" data-testid="workflow-comments-attachments">
        <label style="font-size: 1.1rem;"
          >{sgettext('$$COMMENTS_ATTACHMENTS$$')}</label
        >
        <ApprovalForm
          bind:comment
          bind:purpose
          purposeReadonly={false}
          editorCommentLabel={sgettext('$$AUTHOR_COMMENTS$$')}
          editorCommentLabelTooltip={sgettext('$$TEXT_INTENDED_REVIEWERS_APPROVERS_APPEAR$$')}
          bind:commentErrors={fieldIsValid.comment.errors}
          bind:purposeErrors={fieldIsValid.purpose.errors}
        />
        <th>
          {sgettext('$$ATTACHMENTS$$')}
          <a
            href="#"
            data-toggle="tooltip"
            title={sgettext('$$LIMIT_5_ATTACHMENTS_100MB$$')}
            style="color:#ccc; margin-left:5px;"
          >
            <i class="fas fa-question-circle" />
          </a>
        </th>

        {#key cleanupAttachments}
          <Attachments
            bind:media
            bind:attachments
            bind:cleanupAttachments
            bind:this={mediaInput}
            allowFileModifications={true}
            activityVersionId={avId}
            showLibrary={() => mediaInput.showFileBrowser()}
          />
        {/key}

        <div style="background-color: #ddd; border-radius: 5px;" class="mt-3" data-testid="comments-log-container">
          {#if approvalComments.length}
            <div
              class="d-flex justify-content-between justify-align-items px-3 py-2 pointer-cursor"
              on:click={() => (isCommentLogExpanded = !isCommentLogExpanded)}
            >
              <label for="commentTitleField" class="mb-0 pointer-cursor" data-testid="comment-title-field">
                {sgettext('$$COMMENT_LOG$$')}{' ('}{approvalComments.length}{')'}
              </label>

              {#if isCommentLogExpanded}
                <span data-testid="comment-log-expanded"><i class="fa fa-chevron-up" /></span>
              {:else}
                <span data-testid="comment-log-collapsed"><i class="fa fa-chevron-down" /></span>
              {/if}
            </div>
          {:else}
            <div class="d-flex justify-align-items pl-3 py-2">
              <label class="mb-0" data-testid="comment-title-field">
                {sgettext('$$COMMENT_LOG$$')}{' ('}{approvalComments.length}{')'} - {sgettext(
                  '$$COMMENTS_2$$'
                )}
              </label>
            </div>
          {/if}

          <div class={isCommentLogExpanded ? 'px-1' : 'hide'}>
            <Comments comments={approvalComments} loading={loadingComments} />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div slot="footer">
    <Button
      name={sgettext('$$CANCEL$$')}
      on:click={onCancel}
      disabled={sending}
      type="secondary"
    />
    <Button
      name={submitButtonText}
      on:click={handleApprove}
      {sending}
      disabled={sending}
    />
  </div>
</Modal>

<ConfirmationModal
  id={'withdrawalModal'}
  title={sgettext('$$WITHDRAW_APPROVAL_REQUEST$$')}
  onYes={withdrawRequest}
  onNo={cancelWithdrawal}
  {sending}
>
  <div slot="message">
    <p>
      {sgettext(
        '$$SURE_WANT_WITHDRAW_REQUEST_APPROVAL$$'
      )}
    </p>
  </div>
</ConfirmationModal>

<style>
  .hide {
    display: none !important;
  }

  .pointer-cursor {
    cursor: pointer;
  }

  .tooltip-parent {
    position: relative;
  }

  .tooltip-parent .tooltiptext {
    visibility: hidden;
    width: 250px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 7px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    left: -250px;
  }

  .tooltip-parent:hover .tooltiptext {
    visibility: visible;
  }
</style>
